import React, { useState, useEffect } from 'react';
import { Box, Grid, Typography } from "@mui/material";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { generateServiceTimeMetrics } from '../../utilityFunctions/DataloveUtil';
import Swal from 'sweetalert';
import CustomLoader from "../../components/CustomLoader";

export default function ServiceTimeChart(props) {
    const { loginUser } = props;
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchServiceTimeMetrics = async () => {
            setLoading(true);
            const serviceTimeMetrics = await generateServiceTimeMetrics(loginUser.jwtToken);
            setLoading(false);

            if (!serviceTimeMetrics) {
                Swal({
                    title: "Error",
                    text: "Failed to fetch service time metrics",
                    icon: "error",
                    button: "Ok",
                });
                return;
            }

            // Sort the data chronologically by month
            const sortedData = (serviceTimeMetrics.chartData || []).sort((a, b) => {
                return a.month.localeCompare(b.month);
            });

            setData(sortedData);
        };
        fetchServiceTimeMetrics();
    }, [loginUser.jwtToken]);

    return (
        <Box sx={{ display: "flex", justifyContent: "center", width: "100%", height: "100%" }}>
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: {xs: "start", sm: "start", md: "center"}, width: "95%", height: "90%", textAlign: "center", marginTop: { xs: "4.5rem", sm: "2rem", md: "0" } }}>
                {loading ? (
                    <CustomLoader />
                ) : (
                    <Grid container direction="row" spacing={1} sx={{display: "flex", justifyContent: "center"}}>
                        <Grid item xs={12}>
                            <Typography variant="h4" sx={{ marginTop: "2rem", fontWeight: "bold" }}>Average Service Time</Typography>
                        </Grid>
                        {data && data.length > 0 ? (
                            <Grid item xs={12} sx={{width: "100%", height: 400}}>
                                <ResponsiveContainer width="100%" height={400}>
                                    <LineChart
                                        data={data}
                                        margin={{
                                            top: 20,
                                            right: 30,
                                            left: 20,
                                            bottom: 5,
                                        }}
                                    >
                                        <CartesianGrid strokeDasharray="3 3" />
                                        <XAxis 
                                            dataKey="month" 
                                            angle={-45} 
                                            textAnchor="end" 
                                            height={70}
                                            tick={{fontSize: 12}}
                                        />
                                        <YAxis 
                                            label={{ 
                                                value: 'Minutes', 
                                                angle: -90, 
                                                position: 'insideLeft',
                                                style: { textAnchor: 'middle' }
                                            }}
                                        />
                                        <Tooltip 
                                            formatter={(value) => [`${value.toFixed(1)} minutes`, 'Average Service Time']}
                                        />
                                        <Legend />
                                        <Line 
                                            type="monotone" 
                                            dataKey="averageServiceTime" 
                                            name="Average Service Time" 
                                            stroke="#01929b" 
                                            activeDot={{ r: 8 }} 
                                        />
                                    </LineChart>
                                </ResponsiveContainer>
                            </Grid>
                        ) : (
                            <Grid item xs={12}>
                                <Typography variant="body1">
                                    No data available.
                                </Typography>                                
                            </Grid>
                        )}
                    </Grid>
                )}           
            </Box>
        </Box>
    );
} 